export default ({ store, redirect, route }) => {
  if (store.getters['auth/check']) {
    if (route.query.redirect) {
      redirect(route.query.redirect)
    }
    return redirect({ name: 'index' })
  }
}
